import axios from "axios";

export const api = axios.create({
    baseURL: 'https://portal.arkadigital.dev.br/v1', // baseURL inicial
    timeout: 60000,
  });
  